import { graphql } from '../../../gql';

// TRIL-367: dedicated query for the per-reply Story Analysis page. Selects the
// full storyAnalysis block (same shape as GET_POST_BY_ID_QUERY) so the heavy
// plugin_results selection stays OFF the reply-detail load (which uses the
// lean GET_REPLY_BY_ID_QUERY). Mirrors the TRIL-275 dedicated-query precedent.
export const GET_REPLY_ANALYSIS_QUERY = graphql(`
  query getReplyAnalysis($replyId: String!) {
    getReplyById(replyId: $replyId) {
      id
      score
      replyCount
      authorId
      storyAnalysis {
        userId
        storyId
        published
        # TRIL-669: gates the envelope-score fallback in AnalysisDashboard. An
        # unattested envelope's overall_score is a client-supplied number.
        serverAttestedAnalysis
        analysis {
          version
          sentiment {
            sentiment_summary
            confidence_explanation
            contribution_explanation
          }
          storyAnalyzer {
            overall_score
            user_recommendations
            interpretations {
              flags
              key_findings
              overall_quality
              recommendations
            }
            plugin_results {
              sentiment {
                primary_sentiment
                confidence
                contribution_to_overall
                scores { negative neutral positive }
              }
              emotion_detection {
                primary_emotion
                secondary_emotion
                emotional_intensity
                emotional_state
                emotion_scores {
                  joy anger fear sadness surprise disgust trust anticipation
                }
              }
              story_summary {
                summary
                key_topics
              }
              topic_relevance {
                primary_topic
                topic_confidence
                is_controversial
                contribution_to_overall
                category_scores {
                  economics environment health personal politics social_issues technology
                }
              }
              advanced_readability {
                average_readability
                flesch_reading_ease
                flesch_kincaid_grade
                gunning_fog_index
                reading_level
                is_accessible
                contribution_to_overall
              }
              quality_metrics {
                grammar_score
                readability_score
                word_count
                sentence_count
                paragraph_count
                spelling_errors
                avg_word_length
                contribution_to_overall
              }
              ai_detection {
                is_likely_ai
                ai_probability
                human_probability
                confidence
                contribution_to_overall
              }
              emotional_manipulation {
                is_manipulative
                manipulation_score
                emotional_intensity
                contribution_to_overall
              }
              misinformation_detection {
                needs_fact_checking
                misinformation_risk
                risk_level
                fact_claims_detected
                contribution_to_overall
              }
              plagiarism_detection {
                is_likely_original
                originality_score
                contribution_to_overall
              }
              spam_detection {
                is_likely_spam
                spam_score
                spam_level
                contribution_to_overall
              }
            }
          }
        }
      }
    }
  }
`);
